module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-ANGELLIST.bc3b1816.png";